import React , {useEffect, useState}from 'react';
import { GridRow, Image , Icon, Container ,FeedLike, Loader ,Dimmer, GridColumn , FeedSummary, FeedLabel, FeedExtra, FeedEvent, FeedDate, FeedContent, Feed,FeedMeta} from 'semantic-ui-react';
import {map } from "lodash"
import {Link, Switch} from "react-router-dom"
import { useQuery } from '@apollo/client';
import { GET_PUBLICATIONS_FOLLOWEDS_2  , GET_PUBLICATIONS_FOLLOWEDS } from '../../../gql/publication';
import Actions from '../../../components/ModalPublicasion /Actions';
import ActionsVent from "../../../components/ModalPublicasion /ActionsVent"
import ModalPubication from '../../../components/ModalPublicasion /ModalPubication';
import icona from "../../../../src/asets/png/icona.jpg";
import Public from '../../../components/Publications/public';
import Price from '../../../components/Publications/public/pricefed';
import TitlePublic from '../../../components/ModalPublicasion /titlepublic/TitlePublic';
import Folllowers from '../../../components/User/Profile/Folllowers';
import UserNotFollow from '../../../components/Home/UserNotFollow';
import UserNot from '../../Bienvenida/UserNot/UserNot';
import TitleEx from "../FedExterior/TitleEx/TitleEx"
import Samples from '../../Bienvenida/Samples/Samples';
import Footer from '../Footer/Footer';

import "./FeedFollow.scss";

export default function FeedFollow (props) {

  const {publication} = props;
  const [showModal, setShowModal] = useState (false);
  const [publicationSelect, setPublicationSelect ] = useState (null);
  const {data, loading, startPolling, stopPolling , refetch }= useQuery (GET_PUBLICATIONS_FOLLOWEDS_2);
 const { data:data1, loading:loading1 ,refetch: refetch1} = useQuery (GET_PUBLICATIONS_FOLLOWEDS)
   
  //const {data1 , loading0}= useQuery (GET_PUBLICS)
  //const {pub , setPub} = useState (null);
  

  

/*useEffect(() => {
  startPolling(2000)
  return () => {
   stopPolling();
  } 
 

}, [startPolling,stopPolling])*/

  if(loading) return null;

  const {getPublicationsFolloweds2 } = data;


  console.log (data)
  
  
  const openPublication = (publication) => {
    setPublicationSelect(publication);

    setShowModal(true);

  };

  if(loading1) return null;

  const {getPublicationsFolloweds } = data1;


  console.log (data1)



  return (

    <>
    
    <GridColumn mobile={16} computer = {16}>   

      {map (getPublicationsFolloweds2 ,(publication, index) => (
          
    
    <Feed className='feedfollow'>
    <FeedEvent>
    
      <FeedLabel image={publication.idUser.avatar}  avatar/>
      
      <FeedContent>
        <FeedDate>{( new Date(publication.createAt*1)).toLocaleDateString() }</FeedDate>
        <FeedSummary>
        <Link to = {`/${publication.idUser.username}`}>
          <a>{publication.idUser.name }  </a>  
          </Link>
            ..Publico un Articulo 
         
        </FeedSummary>
        <FeedExtra  images  onClick={ ()=> openPublication (publication ) } >
          <a>
            <img src={publication.file}className='feedfollow_box_photo' />
          </a>
          <a>
            <img src={publication.file2} />
          </a>
        </FeedExtra>
        <FeedMeta>
          <FeedLike>
            
            <Icon name='map pin' /> {publication.area}
          </FeedLike>
        </FeedMeta>
      </FeedContent>
    </FeedEvent>
  </Feed>
    
    ))}




    </GridColumn>


    {showModal && (
      <ModalPubication  show= {showModal}  setShow= {setShowModal}    publication={publicationSelect}    /> )};

<GridColumn mobile={16} computer = {16}>     
    
    
    <UserNot />

    

    </GridColumn>

<Footer/>

    
</>
  
  
 ) 
  
  };

  /*<feed>
<FeedEvent>  
<GridColumn className='feedfollow' mobile = {16}  computer = {8}>
   
  
        {map(getPublicationsFolloweds2 ,(publication, index) => (
          
          <div key = {index} className = "feedfollow_box" >
                                                

            <Link to = {`/${publication.idUser.username}`}>
              <div className='feedfollow_box_user' >
               
                <FeedLabel src= {publication.idUser.avatar  || icona }  />
                <span>{publication.idUser.name}</span>
                <p>{( new Date(publication.createAt*1)).toLocaleDateString() }</p>  
                </div>
                <div className='feed_box_user' mobile={16}>
                
              <TitlePublic publication={publication}/>
      </div>  
    

    </Link>
    <Link to = {`/Publication/${publication._id}`}>
            <Image className='feedfollow_box_photo'
             src= {publication.file} 
            onClick={ ()=> openPublication (publication )}
            
            />

</Link>
            <div className='feedfollow_box_action'>

            
            
            
            </div>

            <GridRow centered className='feedfollow_box_user' >
<GridRow centered className='price'>

 <h2 > <Icon name = "dollar"/>{publication.precio} </h2>

 
  

 </GridRow>
 
</GridRow>

           

              
              
          </div>
       


        ))}


        
    </GridColumn>

    
</FeedEvent>
</feed>  */
